module.exports = __webpack_public_path__ + "static/media/low_fat.a3facc3f.png";